import { useMaintenance } from "./useMaintenance";
import { useIsAdmin } from "./useIsAdmin";

/** Returns true when the site is in read-only mode and the current user is
 *  not an admin. Use this to disable primary write CTAs client-side. */
export function useMaintenanceDisabled() {
  const { config } = useMaintenance();
  const { data: isAdmin } = useIsAdmin();
  return config.mode === "read_only" && !isAdmin;
}
